import axios from "axios";

export default {
    async isValidAddress(address, currency, opts = {}) {
        if (address === null) {
            return false;
        }
        
        if (address.length !== 66) {
            return false;
        }

        const url = "https://rpc-mainnet.supra.com/rpc/v1/accounts/" + address;
        try {
            const response = await axios.get(url);
            return response.data && response.data.sequence_number !== undefined;
        } catch (error) {
            return false;
        }
    },
};
